var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendarTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.95833 17.4163C3.52292 17.4163 3.15017 17.2613 2.8401 16.9512C2.53003 16.6412 2.375 16.2684 2.375 15.833V4.74967C2.375 4.31426 2.53003 3.94151 2.8401 3.63145C3.15017 3.32138 3.52292 3.16634 3.95833 3.16634H4.75V1.58301H6.33333V3.16634H12.6667V1.58301H14.25V3.16634H15.0417C15.4771 3.16634 15.8498 3.32138 16.1599 3.63145C16.47 3.94151 16.625 4.31426 16.625 4.74967V9.24238C16.3743 9.12363 16.117 9.02467 15.8531 8.94551C15.5892 8.86634 15.3188 8.80697 15.0417 8.76738V7.91634H3.95833V15.833H8.94583C9.0382 16.1233 9.14705 16.4004 9.2724 16.6643C9.39774 16.9281 9.54618 17.1788 9.71771 17.4163H3.95833ZM14.25 18.208C13.1549 18.208 12.2214 17.8221 11.4495 17.0502C10.6776 16.2783 10.2917 15.3448 10.2917 14.2497C10.2917 13.1545 10.6776 12.221 11.4495 11.4492C12.2214 10.6773 13.1549 10.2913 14.25 10.2913C15.3451 10.2913 16.2786 10.6773 17.0505 11.4492C17.8224 12.221 18.2083 13.1545 18.2083 14.2497C18.2083 15.3448 17.8224 16.2783 17.0505 17.0502C16.2786 17.8221 15.3451 18.208 14.25 18.208ZM15.576 16.1299L16.1302 15.5757L14.6458 14.0913V11.8747H13.8542V14.408L15.576 16.1299Z",
    fill: "#344054"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarTime);
export default __webpack_public_path__ + "static/media/icon-calendar-time.0ac50cdec3688fc942bb431b5df85a09.svg";
export { ForwardRef as ReactComponent };